if (!customElements.get('team-component')) {
  class TeamComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.section = this.closest('.team');
      this.sliderWrapper = this.querySelector('.team__members');
      this.enableSlider = this.dataset.enableSlider === 'true';
      this.sliderInstance = false;

      if (!this.enableSlider || !this.sliderWrapper) return;

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
      document.addEventListener('matchMobile', () => this.init());
      document.addEventListener('unmatchMobile', () => this.init());
    }

    init() {
      if (typeof FoxTheme === 'undefined' || !FoxTheme.Carousel) {
        setTimeout(() => this.init(), 50);
        return;
      }
      this.initSlider();
    }

    initSlider() {
      if (!this.section || !this.sliderWrapper) return;

      const navNext = this.section.querySelector('.swiper-btn-next');
      const navPrev = this.section.querySelector('.swiper-btn-prev');

      const sliderOptions = {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        loop: true,
        threshold: 2,
        navigation:
          navNext && navPrev
            ? {
                nextEl: navNext,
                prevEl: navPrev,
              }
            : undefined,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add('swiper');
        this.sliderWrapper.classList.add('swiper-wrapper');
        this.sliderInstance = new FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        if (FoxTheme.a11y && FoxTheme.a11y.getFocusableElements) {
          const focusableElements = FoxTheme.a11y.getFocusableElements(this);
          focusableElements.forEach((el) => {
            el.addEventListener('focusin', () => {
              const slide = el.closest('.swiper-slide');
              if (slide && this.sliderInstance && this.sliderInstance.slider) {
                this.sliderInstance.slider.slideTo(
                  this.sliderInstance.slider.slides.indexOf(slide)
                );
              }
            });
          });
        }
      }

      if (typeof Shopify !== 'undefined' && Shopify.designMode && this.sliderInstance && this.sliderInstance.slider) {
        document.addEventListener('shopify:block:select', (e) => {
          if (!e.detail || e.detail.sectionId !== this.sectionId) return;
          const index = Number(e.target.dataset.index);
          if (!isNaN(index)) this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }

    destroySlider() {}
  }
  customElements.define('team-component', TeamComponent);
}
